import React from 'react'
import Box from '@mui/material/Box'
import SettingTitle from '../SettingTitle/SettingTitle'
import FormInputField from '../FormInputField/FormInputField'
import { BoxInputFieldProps } from '../propsTypes'

const BoxInputField = ({
  title,
  alignTitleCenter,
  placeholder,
  value,
  onChange,
  error,
  helperText,
}: BoxInputFieldProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: '10px',
        width: '100%',
      }}>
      <SettingTitle title={title} alignCenter={alignTitleCenter} />
      <FormInputField
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        error={error}
        helperText={helperText}
      />
    </Box>
  )
}

export default BoxInputField
